import { all } from 'redux-saga/effects';
import CarouselItemSaga from './carousel-items/carousel-items-saga.js';
import UserSessionSaga from './user-session/user-session-saga.js';
import CategoriesSaga from './categories/categories-saga.js';
import ProductsSaga from './products/products-saga.js';
import SettingsSaga from './settings/settings-saga.js';
import SpecialistsSaga from './specialists/specialists-saga.js';
import TradeInSimulationsSaga from './trade-in-simulations/saga.js';

export default function* sagaConfig() {
  yield all([
    ...UserSessionSaga,
    ...CarouselItemSaga,
    ...CategoriesSaga,
    ...ProductsSaga,
    ...SettingsSaga,
    ...SpecialistsSaga,
    ...TradeInSimulationsSaga,
  ]);
}
